import React from 'react';
import PropTypes from 'prop-types';

import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import geocoder from '~/config/geocoder';

const containerStyle = {
  width: '100%',
  height: '100%',
};

const center = {
  lat: -15.7217175,
  lng: -48.0774438,
};

export default function MapComponent({ onClick, markers, zoom }) {
  return (
    <LoadScript loadingElement={<p />} googleMapsApiKey={geocoder.apiKey}>
      <GoogleMap
        id="map"
        onClick={onClick}
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
      >
        {markers.map((coord, index) => (
          <Marker key={index} position={coord} />
        ))}
      </GoogleMap>
    </LoadScript>
  );
}

MapComponent.propTypes = {
  onClick: PropTypes.func,
  polyline: PropTypes.bool,
  markers: PropTypes.array,
  zoom: PropTypes.number,
};

MapComponent.defaultProps = {
  onClick: null,
  polyline: false,
  markers: [],
  zoom: 4,
};
